/* eslint-disable max-len */
import React, { useState, useContext } from 'react';
import proptypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  bool,
  extend,
  string,
  shape,
  QueryProvider,
  QueryContext,
  params
} from '@thd-nucleus/data-sources';
import {
  isAppliance,
  getLoyaltyMembershipInput,
  getDisplayProducts,
} from '../utils/helpers';
import { RecsProductPod } from '../core/RecsProductPod';
import { LoadingPlaceholder } from '../core/LoadingPlaceholder';

const { bool: boolType, any, string: stringType, } = proptypes;

const Wrapper = ({ children }) => children;
Wrapper.dataModel = extend({
  product: params({ itemId: string().isRequired() }).shape({
    dataSource: string()
  })
}, RecsProductPod);

const MoreLikeThisPlp = (
  {
    data = null,
    scheme = 'drecs',
    storeId,
    hideATC = false,
    hideFavorites = true,
    hideBadge = false,
    membershipInformation,
    zipCode,
    hideSwatches = true,
    analyticsAnchorProductSku = '',
    parent,
    zoneName,
    zonePosition,
    podResults,
    brandTitleMaxLine,
    hideRating = false,
    noATCFulfillment = true,
    hidePrice = false,
    loading,
    telemetryKey
  }
) => {
  const { customer } = useContext(ExperienceContext);
  const { defaultVariables } = useContext(QueryContext) || {};

  const isB2BCustomer = customer?.type === 'b2b';

  const qtxDefaultVariables = {
    storeId,
    zipCode,
    installationServices: false,
    loyaltyMembershipInput: getLoyaltyMembershipInput(membershipInformation),
    skipFavoriteCount: !!isB2BCustomer,
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  const { products } = data || {};

  const [filtered] = useState([]);
  const [isCategorySelected] = useState(false);

  let displayProducts = getDisplayProducts(isCategorySelected, filtered, products);

  return (
    <>
      {loading ? <LoadingPlaceholder itemsCount={2} /> : displayProducts?.length > 0 && (
        <div className="sui-grid sui-grid-cols-2 sui-pr-2 sui-pl-2 sui-gap-2">
          <QueryProvider
            dataSource={scheme}
            cacheKey={`${scheme}-recommendations-carousel`}
            defaultVariables={qtxDefaultVariables}
          >
            {displayProducts.map((dynamicProduct, idx) => {
              const { product } = dynamicProduct;
              const { itemId } = product;
              const { canonicalUrl } = product?.identifiers || {};
              const { preferredPriceFlag } = product.pricing;
              return (
                <Wrapper key={idx}>
                  <RecsProductPod
                    itemId={itemId}
                    key={itemId}
                    position={idx}
                    storeId={storeId}
                    scheme={scheme}
                    anchorProduct={analyticsAnchorProductSku}
                    parent={parent}
                    zoneName={zoneName}
                    zonePosition={zonePosition}
                    podResults={podResults}
                    hideSwatches={hideSwatches}
                    hideFavorites={hideFavorites}
                    hideBadge={hideBadge}
                    hideATC={hideATC}
                    hidePrice={hidePrice}
                    hideRating={hideRating}
                    preferredPriceFlag={preferredPriceFlag}
                    brandTitleMaxLine={brandTitleMaxLine}
                    strategy={dynamicProduct?.strategy}
                    noATCFulfillment={isAppliance(product) ? false : noATCFulfillment}
                    url={canonicalUrl}
                    product={product}
                    telemetryKey={telemetryKey}
                  />
                </Wrapper>
              );
            }
            )}
          </QueryProvider>
        </div>
      )}
    </>
  );
};

const productModel = extend({}, {
  itemId: string(),
  dataSource: string()
}, RecsProductPod.dataModel.product);

export const wrappedProduct1 = shape({
  category: string(),
  description: string(),
  idEndDate: string(),
  idPromoDetails: string(),
  idStartDate: string(),
  strategy: string(),
  isAnchor: bool(),
  product: params({
    dataSource: string()
  })
    .shape(productModel),
  slot: shape({
    description: string(),
    isRequired: bool(),
    name: string()
  })
});
MoreLikeThisPlp.dataModel = extend(Wrapper, wrappedProduct1);

MoreLikeThisPlp.displayName = 'MoreLikeThisPlp';

MoreLikeThisPlp.propTypes = {
  ...RecsProductPod.propTypes,
  // eslint-disable-next-line react/forbid-prop-types
  data: any,
  scheme: stringType,
  storeId: stringType.isRequired,
  hideATC: boolType,
  hideFavorites: boolType,
  hideBadge: boolType,
  hideSwatches: boolType,
  analyticsAnchorProductSku: stringType,
  hideRating: boolType,
  noATCFulfillment: boolType,
  hidePrice: boolType,
  loading: boolType.isRequired,
};

export { MoreLikeThisPlp };
